<template>
  <a-modal
    title="联系客服"
    :visible="visible"
    :width="620"
    :footer="null"
    :maskClosable="false"
    centered
    @cancel="close"
  >
    <div class="customer-service-content">
      <template v-if="wechat">
        <img :src="wechat" alt="客服微信二维码" />
        <div class="customer-service-tip">请使用微信扫描二维码联系客服</div>
      </template>
      <div v-else class="customer-service-empty">暂未配置客服微信</div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'CustomerServiceModal',
  props: {
    wechat: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.customer-service-content {
  min-height: 460px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 0 8px;

  img {
    display: block;
    width: 420px;
    height: 420px;
    max-width: 100%;
    object-fit: contain;
  }

  .customer-service-tip {
    margin-top: 16px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
  }

  .customer-service-empty {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.45);
  }
}
</style>
